/**
 * Approximate latitude/longitude for common NCC-source Indian cities.
 * Used by the State-with-highest-manpower widget to plot city dots inside the state outline.
 */
const CITY_COORDS = {
  // ---------------- Bihar ----------------
  "gaya": [85.00, 24.79],
  "patna": [85.13, 25.59],
  "muzaffarpur": [85.39, 26.12],
  "bhagalpur": [86.97, 25.24],
  "purnia": [87.47, 25.78],
  "darbhanga": [85.90, 26.15],
  "saharsa": [86.60, 25.88],
  "khagaria": [86.47, 25.50],
  "katihar": [87.58, 25.54],
  "samastipur": [85.78, 25.86],
  "buxar": [83.98, 25.56],
  "begusarai": [86.13, 25.42],
  "munger": [86.47, 25.37],
  "chhapra": [84.74, 25.78],
  "saran": [84.74, 25.78],
  "hajipur": [85.21, 25.69],
  "vaishali": [85.18, 25.99],
  "ara": [84.66, 25.55],
  "arrah": [84.66, 25.55],
  "bhojpur": [84.66, 25.55],
  "sasaram": [84.04, 24.95],
  "rohtas": [84.04, 24.95],
  "sitamarhi": [85.49, 26.59],
  "madhubani": [86.07, 26.35],
  "sheohar": [85.30, 26.51],
  "motihari": [84.91, 26.65],
  "east champaran": [84.91, 26.65],
  "bettiah": [84.50, 26.80],
  "west champaran": [84.50, 26.80],
  "nawada": [85.54, 24.89],
  "jehanabad": [84.99, 25.21],
  "aurangabad": [84.37, 24.75],
  "lakhisarai": [86.09, 25.17],
  "sheikhpura": [85.84, 25.14],
  "bihar sharif": [85.52, 25.20],
  "nalanda": [85.52, 25.20],
  "jamui": [86.22, 24.93],
  "banka": [86.92, 24.89],
  "madhepura": [86.79, 25.92],
  "supaul": [86.61, 26.13],
  "araria": [87.51, 26.15],
  "kishanganj": [87.95, 26.10],
  "gopalganj": [84.43, 26.47],
  "siwan": [84.36, 26.22],
  "kaimur": [83.61, 25.04],
  "bhabua": [83.61, 25.04],
  "raxaul": [84.85, 26.99],
  "dehri": [84.18, 24.89],

  // ---------------- Jharkhand ----------------
  "pakur": [87.85, 24.64],
  "ranchi": [85.31, 23.34],
  "dhanbad": [86.43, 23.79],
  "jamshedpur": [86.18, 22.80],
  "bokaro": [86.15, 23.67],
  "deoghar": [86.69, 24.48],
  "hazaribagh": [85.36, 23.99],
  "giridih": [86.31, 24.18],
  "dumka": [87.25, 24.27],
  "sahibganj": [87.64, 25.25],
  "godda": [87.21, 24.83],
  "garhwa": [83.81, 24.16],
  "palamu": [84.07, 24.04],
  "daltonganj": [84.07, 24.04],
  "medininagar": [84.07, 24.04],
  "chaibasa": [85.81, 22.55],
  "west singhbhum": [85.81, 22.55],
  "saraikela": [85.93, 22.69],
  "saraikela kharsawan": [85.93, 22.69],
  "khunti": [85.28, 23.07],
  "simdega": [84.51, 22.62],
  "lohardaga": [84.69, 23.43],
  "gumla": [84.54, 23.04],
  "latehar": [84.50, 23.74],
  "chatra": [84.87, 24.21],
  "koderma": [85.59, 24.47],
  "ramgarh": [85.52, 23.63],
  "jamtara": [86.80, 23.96],
  "rajmahal": [87.83, 25.05],

  // ---------------- Odisha ----------------
  "kendrapara": [86.42, 20.50],
  "bhubaneswar": [85.82, 20.30],
  "cuttack": [85.88, 20.46],
  "puri": [85.83, 19.81],
  "berhampur": [84.79, 19.31],
  "rourkela": [84.85, 22.25],
  "sambalpur": [83.97, 21.47],
  "balasore": [86.94, 21.49],
  "baleswar": [86.94, 21.49],
  "jagatsinghpur": [86.17, 20.26],
  "kendujhar": [85.58, 21.63],
  "keonjhar": [85.58, 21.63],
  "mayurbhanj": [86.74, 21.93],
  "baripada": [86.74, 21.93],
  "ganjam": [84.79, 19.31],
  "khordha": [85.65, 20.18],

  // ---------------- West Bengal ----------------
  "kolkata": [88.36, 22.57],
  "siliguri": [88.43, 26.72],
  "asansol": [86.95, 23.69],
  "howrah": [88.31, 22.59],
  "bongaon": [88.83, 23.07],
  "barasat": [88.49, 22.72],
  "hooghly": [88.39, 22.91],
  "chinsurah": [88.39, 22.91],
  "burdwan": [87.86, 23.25],
  "bardhaman": [87.86, 23.25],
  "durgapur": [87.31, 23.52],
  "purba bardhaman": [87.86, 23.25],
  "paschim bardhaman": [87.31, 23.52],
  "murshidabad": [88.27, 24.18],
  "berhampore": [88.25, 24.10],
  "baharampur": [88.25, 24.10],
  "malda": [88.14, 25.00],
  "english bazar": [88.14, 25.00],
  "birbhum": [87.85, 23.83],
  "suri": [87.53, 23.92],
  "bolpur": [87.69, 23.67],
  "bankura": [87.07, 23.24],
  "purulia": [86.36, 23.34],
  "midnapore": [87.31, 22.43],
  "paschim medinipur": [87.31, 22.43],
  "kharagpur": [87.32, 22.34],
  "krishnanagar": [88.49, 23.40],
  "nadia": [88.49, 23.40],
  "north 24 parganas": [88.49, 22.72],
  "south 24 parganas": [88.39, 22.16],
  "alipurduar": [89.53, 26.49],
  "jalpaiguri": [88.72, 26.52],
  "cooch behar": [89.45, 26.32],
  "darjeeling": [88.27, 27.04],
  "raiganj": [88.13, 25.62],
  "uttar dinajpur": [88.13, 25.62],
  "dakshin dinajpur": [88.77, 25.55],
  "balurghat": [88.77, 25.55],
  "kalimpong": [88.47, 27.07],

  // ---------------- UP ----------------
  "lucknow": [80.95, 26.85],
  "varanasi": [82.97, 25.32],
  "agra": [78.01, 27.18],
  "noida": [77.39, 28.54],
  "ghaziabad": [77.46, 28.67],
  "kanpur": [80.35, 26.45],
  "allahabad": [81.85, 25.43],
  "prayagraj": [81.85, 25.43],
  "gorakhpur": [83.36, 26.76],
  "bareilly": [79.42, 28.36],
  "meerut": [77.71, 28.99],
  "aligarh": [78.08, 27.88],
  "moradabad": [78.78, 28.84],
  "saharanpur": [77.55, 29.97],
  "mathura": [77.67, 27.49],
  "firozabad": [78.40, 27.15],

  // ---------------- Maharashtra ----------------
  "mumbai": [72.88, 19.07],
  "pune": [73.86, 18.52],
  "nagpur": [79.09, 21.15],
  "nashik": [73.79, 19.99],
  "aurangabad mh": [75.34, 19.88],
  "thane": [72.97, 19.22],
  "kolhapur": [74.24, 16.71],
  "solapur": [75.91, 17.66],

  // ---------------- Delhi / Haryana / Punjab ----------------
  "delhi": [77.21, 28.61],
  "new delhi": [77.21, 28.61],
  "gurugram": [77.03, 28.46],
  "gurgaon": [77.03, 28.46],
  "faridabad": [77.31, 28.41],
  "ludhiana": [75.86, 30.90],
  "amritsar": [74.87, 31.63],
  "chandigarh": [76.78, 30.73],

  // ---------------- South ----------------
  "bengaluru": [77.59, 12.97],
  "bangalore": [77.59, 12.97],
  "hyderabad": [78.49, 17.39],
  "chennai": [80.27, 13.08],
  "tirupati": [79.42, 13.63],
  "coimbatore": [76.96, 11.02],
  "madurai": [78.12, 9.93],

  // ---------------- Gujarat / Rajasthan ----------------
  "ahmedabad": [72.57, 23.02],
  "surat": [72.83, 21.17],
  "vadodara": [73.20, 22.31],
  "jaipur": [75.79, 26.91],
  "udaipur": [73.71, 24.58],
  "rajkot": [70.78, 22.30],

  // ---------------- MP ----------------
  "indore": [75.86, 22.72],
  "bhopal": [77.41, 23.26],
  "jabalpur": [79.95, 23.18],
  "gwalior": [78.18, 26.22],

  // ---------------- North-East / NE alliterates ----------------
  "guwahati": [91.74, 26.14],
  "dispur": [91.79, 26.14],
  "agartala": [91.28, 23.83],
  "shillong": [91.88, 25.58],
};

// Common spelling-variation map. Lower-cased, trimmed user input is normalised
// against these aliases BEFORE the main table lookup. Cheap and effective at
// catching the kind of typos contractors enter (e.g. "Buxer" → "Buxar").
const ALIASES = {
  "buxer": "buxar",
  "buxor": "buxar",
  "bongaon ": "bongaon",
  "bangaon": "bongaon",
  "samasthipur": "samastipur",
  "sumastipur": "samastipur",
  "patana": "patna",
  "paatna": "patna",
  "bhagalpore": "bhagalpur",
  "muzaffarpore": "muzaffarpur",
  "musaffarpur": "muzaffarpur",
  "purneya": "purnia",
  "purnea": "purnia",
  "darbhang": "darbhanga",
  "gayaa": "gaya",
  "bhopaal": "bhopal",
  "calcutta": "kolkata",
  "kolakata": "kolkata",
  "kalkota": "kolkata",
  "kolkatta": "kolkata",
  "kolkota": "kolkata",
  "bombay": "mumbai",
  "bangalor": "bengaluru",
  "banglore": "bengaluru",
  "bengalore": "bengaluru",
  "hydrabad": "hyderabad",
  "secunderabad": "hyderabad",
  "madras": "chennai",
};

function canon(s) {
  return s.toString().trim().toLowerCase().replace(/\s+/g, " ");
}

export function coordsForCity(city) {
  if (!city) return null;
  const k = canon(city);
  if (CITY_COORDS[k]) return CITY_COORDS[k];
  if (ALIASES[k] && CITY_COORDS[ALIASES[k]]) return CITY_COORDS[ALIASES[k]];
  // Fallback: drop any trailing "district"/"dist" qualifier
  const stripped = k.replace(/\s+(district|dist|dt\.?)$/, "");
  if (stripped !== k && CITY_COORDS[stripped]) return CITY_COORDS[stripped];
  return null;
}
